import { render, staticRenderFns } from "./TaxDetailHeader.vue?vue&type=template&id=022def4e&"
import script from "./TaxDetailHeader.vue?vue&type=script&lang=js&"
export * from "./TaxDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./TaxDetailHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports